import Vue from "vue";
import VueRouter from "vue-router";
import PatientOriginalAvatarView from "../components/episode_of_care/PatientOriginalAvatarView.vue";
import Login from "../components/auth/Login.vue";
import ForgotPassword from "../components/auth/ForgotPassword.vue";
import ResetCode from "../components/auth/ResetCode.vue";
import ResetPassword from "../components/auth/ResetPassword.vue";
import TwoFactorAuth from "../components/auth/TwoFactorAuth.vue";
import Workspace from "../components/workspace/WorkspaceIndex.vue";
import { getToken, setToken } from "../helpers/session";
import store from "../store";

Vue.use(VueRouter);

const authNotRequiredRoutes = [
  "Login",
  "TwoFactorAuth",
  "ForgotPassword",
  "ResetCode",
  "ResetPassword"
];

const routes = [
  {
    path: "/login/",
    name: "Login",
    component: Login
  },
  {
    path: "/forgot-password/",
    name: "ForgotPassword",
    component: ForgotPassword
  },
  {
    path: "/reset-code/",
    name: "ResetCode",
    component: ResetCode
  },
  {
    path: "/reset-password/:code",
    name: "ResetPassword",
    component: ResetPassword
  },
  {
    path: "/two-factor-auth/:key",
    name: "TwoFactorAuth",
    component: TwoFactorAuth
  },
  {
    path: "/",
    name: "WorkspaceIndex",
    component: Workspace
  },
  {
    path: "/eoc-form-demographics",
    name: "HomeEocFormDemographics",
    component: Workspace
  },
  {
    path: "/eoc-form-eoc",
    name: "HomeEocFormEoc",
    component: Workspace
  },
  {
    path: "/eoc-form-insurances",
    name: "HomeEocFormInsurance",
    component: Workspace
  },
  {
    path: "/eoc-form-contacts",
    name: "HomeEocFormContacts",
    component: Workspace
  },
  {
    path: "/eoc-form-guarantors",
    name: "HomeEocFormGuarantors",
    component: Workspace
  },
  {
    path: "/eoc-form-allergies",
    name: "HomeEocFormAllergies",
    component: Workspace
  },
  {
    path: "/eoc-form-additional-information",
    name: "HomeEocFormAdditionalInformation",
    component: Workspace
  },
  {
    path: "/eoc-form-case-load",
    name: "HomeEocFormCaseLoad",
    component: Workspace
  },
  {
    path: "/view-original-avatar/:token/:avatarId",
    name: "PatientOriginalAvatarView",
    component: PatientOriginalAvatarView
  },
  {
    path: "/episode-of-care/:id",
    name: "PatientSummaryView",
    component: Workspace,
    beforeEnter: (to, from, next) => {
      store.commit(`layout/addEocTab`, to.params.id);
      if (to.query.reload || from.name == null) {
        next({ path: "/" });
      } else {
        next(false);
      }
    }
  },
  {
    path: "/document/:id",
    name: "DocumentView",
    component: Workspace,
    beforeEnter: (to, from, next) => {
      store.commit(`layout/setDocumentView`, to.params.id);
      if (to.query.reload || from.name == null) {
        next({ path: "/" });
      } else {
        next(false);
      }
    }
  },
  {
    path: "/create-document",
    name: "DocumentCreate",
    component: Workspace,
    props: true,
    beforeEnter: async (to, from, next) => {
      if (to.query?.parentDocumentId) {
        await store.dispatch(
          `layout/generateDefaultValuesForTreatmentPlanReview`,
          to.query
        );
      } else {
        store.commit(`layout/setTreatmentPlanDefaultDataFromToDo`, null);
      }
      store.commit(`layout/setDocumentEditor`, parseProps(to.query));
      if (to.query.reload || from.name == null) {
        next({ path: "/" });
      } else {
        next(false);
      }
    }
  },
  {
    path: "/home",
    name: "Home",
    component: Workspace,
    beforeEnter: (to, from, next) => {
      store.commit(`layout/setSelectedSideBarItem`, "dashboard");
      if (to.query.reload || from.name == null) {
        next({ path: "/" });
      } else {
        next(false);
      }
    }
  },
  {
    path: "/search-patient-zoho",
    name: "SearchPatientZoho",
    query: {
      patientName: "",
      patientDobShort: "",
      patientEmail: "",
      patientPhone: ""
    },
    component: Workspace,
    beforeEnter: (to, from, next) => {
      store.commit(`layout/searchPatientZoho`, to.query);
      if (to.query.reload || from.name == null) {
        next({ path: "/" });
      } else {
        next(false);
      }
    }
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  let token = getToken();

  if (to.name === "ResetPassword" && token) {
    setToken("");
    token = null;
  }

  if (authNotRequiredRoutes.indexOf(to.name) == -1 && !token) {
    next({
      name: "Login",
      ...(to.path != "/" ? { query: { redirect: to.path } } : {})
    });
  } else if (authNotRequiredRoutes.indexOf(to.name) >= 0 && token) {
    next({ path: "/" });
  } else {
    if (to.query.location) {
      localStorage.setItem("selectedLocation", to.query.location);
      window.history.pushState(
        null,
        document.title,
        location.href + to.path.substring(1) + "?reload=1"
      );
      location.reload();
    } else {
      next();
    }
  }
});

const parseProps = queryProps => {
  for (const key in queryProps) {
    if (Object.hasOwnProperty.call(queryProps, key)) {
      if (queryProps[key] === "true") {
        queryProps[key] = true;
      } else if (queryProps[key] === "false") {
        queryProps[key] = false;
      }
    }
  }
  return queryProps;
};

export default router;
